import { AuditEntity } from "@app/common";
import { Unit, UnitPrice } from "@app/core";
import { BundleProduct, ProductType, ResellerProductType } from "@app/products-base";
import { OrderItemBundle } from "./order-item-bundle";

export class OrderItemBase extends AuditEntity {
	name: string;
	nameIntern: string;
	quantity: number = 1;
	internalQuantity: number;
	regularUnitPrice: UnitPrice = new UnitPrice();
	reducedUnitPrice: UnitPrice = new UnitPrice();
	regularPrice: UnitPrice = new UnitPrice();
	reducedPrice: UnitPrice = new UnitPrice();
	shippingCost: UnitPrice = new UnitPrice();
	productType: ProductType;
	resellerProductType: ResellerProductType;
	unit: Unit;
	productId: number | null;
	product: BundleProduct;
	orderItemBundleId: number | null;
	orderItemBundle: OrderItemBundle;
}